import React, { createContext, ReactElement, useContext } from 'react';
import { CreateBusinessInsight } from 'use-case/widgets/create/createBusinessInsightUseCase';
import { DeleteTextBlock } from 'use-case/widgets/delete/deleteTextBlockUseCase';

export type BusinessInsightDispatch = {
    createBusinessInsight: CreateBusinessInsight;
    deleteBusinessInsight: DeleteTextBlock;
};

export type BusinessInsightProviderType = {
    createBusinessInsight: CreateBusinessInsight;
    deleteBusinessInsight: DeleteTextBlock;
    children: ReactElement;
};

export const BusinessInsightContext = createContext({} as BusinessInsightDispatch);

export const useBusinessInsight = (): BusinessInsightDispatch => useContext(BusinessInsightContext);

export const BusinessInsightProvider = (props: BusinessInsightProviderType): ReactElement => {
    const { children, createBusinessInsight, deleteBusinessInsight } = props;

    return (
        <BusinessInsightContext.Provider value={{ createBusinessInsight, deleteBusinessInsight }}>
            {children}
        </BusinessInsightContext.Provider>
    );
};

export default useBusinessInsight;
